// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Future from "rescript-future/src/Future.res.js";
import * as Request from "../../core/Request.res.js";
import * as FuturePromise from "rescript-future/src/FuturePromise.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let Raw = {};

let query = Client.gql(["query variants($filterBy: InputVariantsQueryFilter)  {\nvariants(first: 1, filterBy: $filterBy)  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \nformattedName  \nformattedDescription  \nstockKeepingUnit  \npurchasedPrice  \npackaging  \nstock  {\n__typename  \nrawQuantity  \n}\n\nbulk  \ncapacityUnit  \ncapacityPrecision  \nshop  {\n__typename  \nid  \n}\n\nproduct  {\n__typename  \nkind  \ntax  {\n__typename  \nvalue  \n}\n\n}\n\n}\n\n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.variants;
  let value$2 = value$1.edges;
  return {
    variants: {
      __typename: value$1.__typename,
      edges: value$2.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.stockKeepingUnit;
        let value$3 = value$1.purchasedPrice;
        let value$4 = value$1.packaging;
        let value$5 = value$1.stock;
        let value$6 = value$5.rawQuantity;
        let value$7 = value$1.bulk;
        let value$8 = value$1.capacityUnit;
        let value$9 = value$1.capacityPrecision;
        let value$10 = value$1.shop;
        let value$11 = value$1.product;
        let value$12 = value$11.kind;
        let tmp;
        switch (value$12) {
          case "BEER" :
            tmp = "BEER";
            break;
          case "SIMPLE" :
            tmp = "SIMPLE";
            break;
          case "SPIRITUOUS" :
            tmp = "SPIRITUOUS";
            break;
          case "WINE" :
            tmp = "WINE";
            break;
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
        let value$13 = value$11.tax;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            formattedName: value$1.formattedName,
            formattedDescription: value$1.formattedDescription,
            stockKeepingUnit: !(value$2 == null) ? value$2 : undefined,
            purchasedPrice: !(value$3 == null) ? value$3 : undefined,
            packaging: !(value$4 == null) ? value$4 : undefined,
            stock: {
              __typename: value$5.__typename,
              rawQuantity: !(value$6 == null) ? value$6 : undefined
            },
            bulk: !(value$7 == null) ? value$7 : undefined,
            capacityUnit: !(value$8 == null) ? value$8 : undefined,
            capacityPrecision: !(value$9 == null) ? value$9 : undefined,
            shop: {
              __typename: value$10.__typename,
              id: value$10.id
            },
            product: {
              __typename: value$11.__typename,
              kind: tmp,
              tax: {
                __typename: value$13.__typename,
                value: value$13.value
              }
            }
          }
        };
      })
    }
  };
}

function serialize(value) {
  let value$1 = value.variants;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.product;
    let value$3 = value$2.tax;
    let value$4 = value$3.value;
    let value$5 = value$3.__typename;
    let tax = {
      __typename: value$5,
      value: value$4
    };
    let value$6 = value$2.kind;
    let kind = value$6 === "SPIRITUOUS" ? "SPIRITUOUS" : (
        value$6 === "BEER" ? "BEER" : (
            value$6 === "WINE" ? "WINE" : "SIMPLE"
          )
      );
    let value$7 = value$2.__typename;
    let product = {
      __typename: value$7,
      kind: kind,
      tax: tax
    };
    let value$8 = value$1.shop;
    let value$9 = value$8.id;
    let value$10 = value$8.__typename;
    let shop = {
      __typename: value$10,
      id: value$9
    };
    let value$11 = value$1.capacityPrecision;
    let capacityPrecision = value$11 !== undefined ? value$11 : null;
    let value$12 = value$1.capacityUnit;
    let capacityUnit = value$12 !== undefined ? value$12 : null;
    let value$13 = value$1.bulk;
    let bulk = value$13 !== undefined ? value$13 : null;
    let value$14 = value$1.stock;
    let value$15 = value$14.rawQuantity;
    let rawQuantity = value$15 !== undefined ? value$15 : null;
    let value$16 = value$14.__typename;
    let stock = {
      __typename: value$16,
      rawQuantity: rawQuantity
    };
    let value$17 = value$1.packaging;
    let packaging = value$17 !== undefined ? value$17 : null;
    let value$18 = value$1.purchasedPrice;
    let purchasedPrice = value$18 !== undefined ? value$18 : null;
    let value$19 = value$1.stockKeepingUnit;
    let stockKeepingUnit = value$19 !== undefined ? value$19 : null;
    let value$20 = value$1.formattedDescription;
    let value$21 = value$1.formattedName;
    let value$22 = value$1.id;
    let value$23 = value$1.__typename;
    let node = {
      __typename: value$23,
      id: value$22,
      formattedName: value$21,
      formattedDescription: value$20,
      stockKeepingUnit: stockKeepingUnit,
      purchasedPrice: purchasedPrice,
      packaging: packaging,
      stock: stock,
      bulk: bulk,
      capacityUnit: capacityUnit,
      capacityPrecision: capacityPrecision,
      shop: shop,
      product: product
    };
    let value$24 = value.__typename;
    return {
      __typename: value$24,
      node: node
    };
  });
  let value$3 = value$1.__typename;
  let variants = {
    __typename: value$3,
    edges: edges
  };
  return {
    variants: variants
  };
}

function serializeInputObjectDateFilter(inp) {
  let a = inp._after;
  let a$1 = inp._before;
  let a$2 = inp._between;
  return {
    _after: a !== undefined ? a : undefined,
    _before: a$1 !== undefined ? a$1 : undefined,
    _between: a$2 !== undefined ? a$2.map(b => b) : undefined
  };
}

function serializeInputObjectNumberRangeFilter(inp) {
  let a = inp._min;
  let a$1 = inp._max;
  let a$2 = inp._between;
  return {
    _min: a !== undefined ? a : undefined,
    _max: a$1 !== undefined ? a$1 : undefined,
    _between: a$2 !== undefined ? a$2.map(b => b) : undefined
  };
}

function serializeInputObjectInFilter(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}

function serializeInputObjectNullableStringEqualsFilter(inp) {
  let a = inp._equals;
  return {
    _equals: a !== undefined ? a : undefined
  };
}

function serializeInputObjectInputVariantsQueryFilter(inp) {
  let a = inp.shopIds;
  let a$1 = inp.stockKeepingUnit;
  let a$2 = inp.ean13;
  let a$3 = inp.active;
  let a$4 = inp.archived;
  let a$5 = inp.createdAt;
  let a$6 = inp.updatedAt;
  let a$7 = inp.categoryId;
  let a$8 = inp.supplierId;
  let a$9 = inp.stock;
  let a$10 = inp.producer;
  return {
    shopIds: a !== undefined ? serializeInputObjectInFilter(a) : undefined,
    stockKeepingUnit: a$1 !== undefined ? ({
        _equals: a$1._equals
      }) : undefined,
    ean13: a$2 !== undefined ? ({
        _equals: a$2._equals
      }) : undefined,
    active: a$3 !== undefined ? ({
        _equals: a$3._equals
      }) : undefined,
    archived: a$4 !== undefined ? (
        a$4 === "ONLY" ? "ONLY" : (
            a$4 === "INCLUDED" ? "INCLUDED" : "EXCLUDED"
          )
      ) : undefined,
    createdAt: a$5 !== undefined ? serializeInputObjectDateFilter(a$5) : undefined,
    updatedAt: a$6 !== undefined ? serializeInputObjectDateFilter(a$6) : undefined,
    categoryId: a$7 !== undefined ? serializeInputObjectNullableStringEqualsFilter(a$7) : undefined,
    supplierId: a$8 !== undefined ? serializeInputObjectNullableStringEqualsFilter(a$8) : undefined,
    stock: a$9 !== undefined ? serializeInputObjectNumberRangeFilter(a$9) : undefined,
    producer: a$10 !== undefined ? ({
        _equals: a$10._equals
      }) : undefined
  };
}

function serializeInputObjectStringEqualsFilter(inp) {
  return {
    _equals: inp._equals
  };
}

function serializeInputObjectBooleanEqualsFilter(inp) {
  return {
    _equals: inp._equals
  };
}

function serializeVariables(inp) {
  let a = inp.filterBy;
  return {
    filterBy: a !== undefined ? serializeInputObjectInputVariantsQueryFilter(a) : undefined
  };
}

function makeVariables(filterBy) {
  return {
    filterBy: filterBy
  };
}

function makeInputObjectInputVariantsQueryFilter(shopIds, stockKeepingUnit, ean13, active, archived, createdAt, updatedAt, categoryId, supplierId, stock, producer, param) {
  return {
    shopIds: shopIds,
    stockKeepingUnit: stockKeepingUnit,
    ean13: ean13,
    active: active,
    archived: archived,
    createdAt: createdAt,
    updatedAt: updatedAt,
    categoryId: categoryId,
    supplierId: supplierId,
    stock: stock,
    producer: producer
  };
}

function makeInputObjectInFilter(_in, param) {
  return {
    _in: _in
  };
}

function makeInputObjectStringEqualsFilter(_equals, param) {
  return {
    _equals: _equals
  };
}

function makeInputObjectBooleanEqualsFilter(_equals, param) {
  return {
    _equals: _equals
  };
}

function makeInputObjectDateFilter(_after, _before, _between, param) {
  return {
    _after: _after,
    _before: _before,
    _between: _between
  };
}

function makeInputObjectNullableStringEqualsFilter(_equals, param) {
  return {
    _equals: _equals
  };
}

function makeInputObjectNumberRangeFilter(_min, _max, _between, param) {
  return {
    _min: _min,
    _max: _max,
    _between: _between
  };
}

function makeDefaultVariables() {
  return {
    filterBy: undefined
  };
}

let Query_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputVariantsQueryFilter: serializeInputObjectInputVariantsQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  serializeInputObjectStringEqualsFilter: serializeInputObjectStringEqualsFilter,
  serializeInputObjectBooleanEqualsFilter: serializeInputObjectBooleanEqualsFilter,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter,
  serializeInputObjectNullableStringEqualsFilter: serializeInputObjectNullableStringEqualsFilter,
  serializeInputObjectNumberRangeFilter: serializeInputObjectNumberRangeFilter,
  makeVariables: makeVariables,
  makeInputObjectInputVariantsQueryFilter: makeInputObjectInputVariantsQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeInputObjectStringEqualsFilter: makeInputObjectStringEqualsFilter,
  makeInputObjectBooleanEqualsFilter: makeInputObjectBooleanEqualsFilter,
  makeInputObjectDateFilter: makeInputObjectDateFilter,
  makeInputObjectNullableStringEqualsFilter: makeInputObjectNullableStringEqualsFilter,
  makeInputObjectNumberRangeFilter: makeInputObjectNumberRangeFilter,
  makeDefaultVariables: makeDefaultVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let Query_refetchQueryDescription = include.refetchQueryDescription;

let Query_use = include.use;

let Query_useLazy = include.useLazy;

let Query_useLazyWithVariables = include.useLazyWithVariables;

let Query = {
  Query_inner: Query_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputVariantsQueryFilter: serializeInputObjectInputVariantsQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  serializeInputObjectStringEqualsFilter: serializeInputObjectStringEqualsFilter,
  serializeInputObjectBooleanEqualsFilter: serializeInputObjectBooleanEqualsFilter,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter,
  serializeInputObjectNullableStringEqualsFilter: serializeInputObjectNullableStringEqualsFilter,
  serializeInputObjectNumberRangeFilter: serializeInputObjectNumberRangeFilter,
  makeVariables: makeVariables,
  makeInputObjectInputVariantsQueryFilter: makeInputObjectInputVariantsQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeInputObjectStringEqualsFilter: makeInputObjectStringEqualsFilter,
  makeInputObjectBooleanEqualsFilter: makeInputObjectBooleanEqualsFilter,
  makeInputObjectDateFilter: makeInputObjectDateFilter,
  makeInputObjectNullableStringEqualsFilter: makeInputObjectNullableStringEqualsFilter,
  makeInputObjectNumberRangeFilter: makeInputObjectNumberRangeFilter,
  makeDefaultVariables: makeDefaultVariables,
  refetchQueryDescription: Query_refetchQueryDescription,
  use: Query_use,
  useLazy: Query_useLazy,
  useLazyWithVariables: Query_useLazyWithVariables
};

function fetchVariantFromSKU(client, shopId, stockKeepingUnit) {
  return Future.map(FuturePromise.fromPromise(client.rescript_query({
    query: query,
    Raw: Raw,
    parse: parse,
    serialize: serialize,
    serializeVariables: serializeVariables
  }, undefined, undefined, undefined, undefined, {
    filterBy: makeInputObjectInputVariantsQueryFilter({
      _in: [shopId]
    }, {
      _equals: stockKeepingUnit
    }, undefined, undefined, "EXCLUDED", undefined, undefined, undefined, undefined, undefined, undefined, undefined)
  })), undefined, response => {
    if (response.TAG !== "Ok") {
      return {
        TAG: "Error",
        _0: Request.serverErrorMessage
      };
    }
    let match = response._0;
    if (match.TAG !== "Ok") {
      return {
        TAG: "Error",
        _0: Request.serverErrorMessage
      };
    }
    let match$1 = match._0;
    if (match$1.error !== undefined) {
      return {
        TAG: "Error",
        _0: Request.serverErrorMessage
      };
    } else {
      return {
        TAG: "Ok",
        _0: Stdlib_Option.map(match$1.data.variants.edges[0], edge => edge.node)
      };
    }
  });
}

let Fetch = {
  fetchVariantFromSKU: fetchVariantFromSKU
};

export {
  Query,
  Fetch,
}
/* query Not a pure module */
